export class CentrePass {
  constructor({ animate, preview, update, animateOff }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.name = "CentrePass";
    this.scene = "Centre Pass";
    this.data = [];
  }

  preview({ options }) {
    this.onAir = false;
    this.data = [];
    this.data.push({ name: "Side", value: { text: options.side } });
    this.sendUpdate(this.scene, this.data);
  }
  animate({ options }) {
    this.onAir = true;
  }
  animateOff({ options }) {
    this.onAir = false;
  }
}
